<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/horimetroKM"> Horímetro KM </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-controle-frota />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="3">
            <v-select
              v-model="equipamentoSelected"
              :items="findEquipamentoAtivo"
              label="Prefixo"
              item-text="prefixo"
              item-value="id"
              persistent-hint
              return-object
              single-line
              :counter="15"
              :rules="[(v) => !!v || 'O prefixo é obrigatório']"
              required
            >
            </v-select>
          </v-col>
          <v-col col="3">
            <v-select
              v-model="equipamentoSelected"
              :items="findEquipamentoAtivo"
              label="Apelido"
              item-text="apelido"
              item-value="id"
              persistent-hint
              return-object
              single-line
              :rules="[(v) => !!v || 'O apelido é obrigatório']"
              required
            >
            </v-select>
          </v-col>
          <v-col cols="3" sm="3">
            <v-text-field
              label="HR KM"
              v-model="horimetroKM.hr_KM"
              :counter="10"
              :rules="[(v) => !!v || 'O HR KM é obrigatório']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="3" sm="3">
                    <v-menu
                      v-model="data1"
                      :close-on-content-click="false"
                      max-width="290"
                    ><template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :value="computedDate()"
                          clearable
                          label="Data HR"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="data_HR = null"
                          required
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="data_HR"
                        @change="data1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col
                  >
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox v-model="horimetroKM.ativo" label="Ativo" :readonly="readOnly"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/horimetroKM" color="error" class="mr-4" v-if="!readOnly">
            Cancelar
          </v-btn>
          <v-btn to="/horimetroKM" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoControleFrota from "../../Tabs/TabControleFrota";
import { editarHorimetroKMAsync } from "../../../services/horimetroKMService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";
import moment from "moment";

export default {
  name: "editarHorimetroKM",
  data: () => ({
    overlay: false,
    valid: true,
    showModal: false,
    prefixo: null,
    prefixoEdit: null,
    apelido: null,
    apelidoEdit: null,
    id: null,    
    idEdit: null,
    idEquipamento: null,
    idEquipamentoEdit: null,
    dataLancamento: null,
    dataLancamentoEdit: null,
    data_HR: null,
    data_HREdit: null,
    ativo: false,
    ativoEdit: false,
    data1: false,
    hr_KM: null,
    hr_KMEdit: null,
  }),
  computed: {
    ...mapState("equipamento", ["equipamentos"]),
    ...mapState("horimetroKM", ["horimetroKM"]),
    ...mapState("produto", ["produtos"]),
    
    findEquipamentoAtivo() {
      return this.equipamentos.filter((m) => {
        return m.ativo === true;
      });
    }

  },
  methods: {
    ...mapActions("horimetroKM", ["atualizarHorimetroKMs","atualizarHorimetroKM"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarHorimetroKMAsync(
          this.horimetroKM.id,
          this.horimetroKM.prefixo,
          this.horimetroKM.apelido,
          this.horimetroKM.hr_KM,
          this.horimetroKM.data_HR,
          this.horimetroKM.dataLancamento,
          this.horimetroKM.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        }
        else {
          this.overlay = false;
          this.$router.push("/horimetroKM");
        }
      }
    },
    computedDate() {
      return this.horimetroKM.data_HR ? moment(this.horimetroKM.data_HR).format("DD/MM/YYYY") : null;
    },
    findEquipamento(Id) {
      return this.equipamentos.find((me) => me.id === Id && me.ativo === true);
    },
    findHorimetro(horimetroKMId) {
      return this.horimetroKMS.filter((p) => {
        return p.Id == horimetroKMId && p.ativo === true;
      });
    },
    doAjax() {
      this.atualizarHorimetroKMs();
    },
    checkAssociacao: async function () {
      if (!this.horimetroKM.ativo) {
        if (!this.horimetros || this.horimetros.length == 0) {
          this.overlay = true;
          await this.atualizarHorimetroKMs();
          this.overlay = false;
        }
        var horimetros = this.findHorimetro(this.horimetroKM.id);
        if (horimetros != null && horimetros.length > 0) {
          this.$alert(
            "O(s) horimetros(s) '" +
              horimetros.map((e) => e.apelido).join("', '") +
              "' estão ativos e associados a essa Família.",
            "Ação não permitida!",
            "error"
          );
          this.horimetroKM.ativo = !this.horimetroKM.ativo;
        }
      }
    }
  },
  created: function () {
    this.doAjax();
    this.readOnly = !getUserPermission(1);
    this.apelido = this.horimetroKM.apelido;
    this.equipamentoSelected = this.findEquipamento(this.horimetroKM.idEquipamento);
  },
  components: {
    TabNavegacaoControleFrota,
  },
};
</script>